module.exports = __webpack_public_path__ + "static/media/sipay.e7bff78e.svg";